import { sendCreateFolderEvent } from '../index';
import { EventAdapter } from './EventAdapter';

export class CreateFolderEventAdapter extends EventAdapter {
  protected amplitudeEventFunction = sendCreateFolderEvent;
  protected intercomEventKey = 'create_folder';

  constructor(settings: { workspace_id?: string } = { workspace_id: null }) {
    super();

    try {
      this.eventData = settings;
    } catch (err) {
      console.error('Error parsing analytics data', err);
    }
  }
}
